<!-- distencion abdominal, eructos, sintomas asociados a cuadros -->
<template>

  <div>

    <b-card 
      v-if="sintomasPrincipal.some( item => item.value === 'distension_abdominal' )"
      border-variant="light"
      class="my-2"
    >
      <b-row>
        <b-col>
          <h5>Distencion Abdominal</h5>
        </b-col>
      </b-row>
      
      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Desde:</div>
        </b-col>

        <b-col class="col-4">
          <v-select
            placeholder="Seleccione una opcion"
            :options="comienzoOpts"
            :reduce="option => option"
            label="text"
            v-model="distencion.desde"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Frecuencia:</div>
        </b-col>

        <b-col class="col-5">
          <v-select
            placeholder="Seleccione una opcion"
            :options="frecuenciasOpts"
            :reduce="option => option"
            label="text"
            v-model="distencion.frecuencia"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Sintomas asociados:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="sintomasAsociadosOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => distencion.sintomas = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Relacion con alimentos:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="relacionAlimentosOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => distencion.relacionAlimentos = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>
      
    </b-card>

    <b-card 
      v-if="sintomasPrincipal.some( item => item.value === 'eructos' )"
      border-variant="light"
      class="my-2"
    >
      <b-row class="my-1">
        <b-col>
          <h5>Eructos</h5>
        </b-col>
      </b-row>
      
      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Desde:</div>
        </b-col>

        <b-col class="col-4">
          <v-select
            placeholder="Seleccione una opcion"
            :options="comienzoOpts"
            :reduce="option => option"
            label="text"
            v-model="eructos.desde"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Frecuencia:</div>
        </b-col>

        <b-col class="col-5">
          <v-select
            placeholder="Seleccione una opcion"
            :options="frecuenciasOpts"
            :reduce="option => option"
            label="text"
            v-model="eructos.frecuencia"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Sintomas asociados:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="sintomasAsociadosOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => eructos.sintomas = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Relacion con alimentos:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="relacionAlimentosOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => eructos.relacionAlimentos = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>
      
    </b-card>

    <b-card 
      v-if="sintomasPrincipal.some( item => item.value === 'sintomas_asociados' )"
      border-variant="light"
      class="my-2"
    >

      <b-row class="my-1">
        <b-col>
          <h5>Sintomas asociados a cuadro</h5>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="sintomasCuadroOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => sintomasCuadro.selected = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>

      
    </b-card>

  </div>
  
</template>

<script>
import vSelect from 'vue-select';
import { addNewOpt } from '@/shared/helpers';

export default {

  name: 'SintomasOtros2',

  components: {
    vSelect
  },

  props: {
    sintomasPrincipal: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      distencion:{
        desde: null,
        frecuencia: null,
        sintomas: null,
        relacionAlimentos:null
      },

      eructos:{
        desde: null,
        frecuencia: null,
        sintomas: null,
        relacionAlimentos:null
      },

      sintomasCuadro:{
        selected:[]
      },

      frecuenciasOpts: [
        { value: 'hora',   text: 'cada hora' },
        { value: 'dia',    text: 'cada dia' },
        { value: 'semana', text: 'cada semana' },
        { value: 'mes',    text: 'cada mes' },
      ],

      comienzoOpts:[
        { value: 'dias',    text: 'días' },
        { value: 'semanas', text: 'semanas' },
        { value: 'meses',   text: 'meses' },
        { value: 'anios',   text: 'años' }
      ],

      sintomasAsociadosOpts: [
        { value: '', text: '' },
      ],

      relacionAlimentosOpts: [
        { value: '', text: '' },
      ],

      sintomasCuadroOpts: [
        { value: "dolor_articular",              text: "Dolor articular" },
        { value: "aftas_bucales",                text: "Aftas bucales" },
        { value: "prurito",                      text: "Prurito" },
        { value: "conjuntivitis",                text: "Conjuntivitis" },
        { value: "lesiones_dermicas",            text: "Lesiones dérmicas" },
        { value: "edema_de_miembros_inferiores", text: "Edema de miembros inferiores" },
        { value: "habito_del_sueno",             text: "Hábito del sueño" },
        { value: "alteracion_del_estado_de_conciencia", text: "Alteración del estado de conciencia" },
        { value: "anemia",          text: "Anemia" },
        { value: "perdida_de_peso", text: "Pérdida de peso" },
        { value: "otros",           text: "Otros" }
      ]
    }
  },

  methods: {
    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },

}
</script>